<div class="process-message-task-sidenav">
  <div class="process-message-task-sidenav__details">
    <sidenav-title
      [closeFunc]="close.bind(this)"
      [title]="sidenavTitle"
      [customActionsTemplate]="headerActions"
    />

    <ng-template #headerActions>
      @if (canShowHeaderActions()) {
        @if (isSendMode()) {
          <div class="sidenav-title-edit align-content-center justify-content-center" (click)="deleteTask()">
            <img draggable="false" src="/assets/img/ic-trash-red-v2.svg" alt="Remove" />
          </div>

          <div
            class="sidenav-title-edit align-content-center justify-content-center"
            (click)="switchToEditMode()"
          >
            <img draggable="false" src="/assets/img/pencil-icon.svg" alt="Edit" />
          </div>
        }
      }
    </ng-template>

    <form [formGroup]="form" class="process-message-task-sidenav__content">
      @if (!isSendMode()) {
        <div class="mb-3">
          <div class="new-select-label">
            {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.templateName' | translate }}
          </div>
          <input-v2
            formControlName="templateName"
            [placeholder]="
              'ProjectsDashboard.stageTasks.messageTaskSidenav.templateNamePlaceholder' | translate
            "
          />
        </div>
      }

      @if (!isSendMode()) {
        <div class="mb-3">
          <div class="new-select-label">
            {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.projectName' | translate }}
          </div>
          <project-selection
            class="w-100"
            [form]="form"
            [addTag]="false"
            [clearable]="false"
            [requiredid]="(data?.projectId ?? '') + ''"
            controlName="projectId"
          />
        </div>
      }

      @if (isSendMode()) {
        <div class="mb-3">
          <employee-search
            [form]="form"
            [projectId]="(data?.projectId ?? '') + ''"
            [controlName]="'assignedToIds'"
            [initialValue]="assignedToInitialValue"
          />
        </div>
      }

      @if (isSendMode()) {
        <div class="mb-3">
          <div class="new-select-label d-flex justify-content-between">
            {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.recipient' | translate }}

            <div class="d-flex">
              <div class="process-message-task-sidenav__add-btn" (click)="toggleBccInput()">
                <svg-icon src="./assets/img/ic_plus_contact.svg" />
                {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.addBcc' | translate }}
              </div>

              <div class="divider"></div>

              <div class="process-message-task-sidenav__add-btn" (click)="toggleCcInput()">
                <svg-icon src="./assets/img/ic_plus_contact.svg" />
                {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.addCc' | translate }}
              </div>
            </div>
          </div>
          <ng-select
            ngSelectExtension
            class="new-select w-100"
            [url]="contactsUrl"
            [responseTransform]="successOnLoadContacts.bind(this)"
            formControlName="to"
            [ignoreLocalSearch]="true"
            [multiple]="false"
            bindValue="email"
            bindLabel="fullName"
            [clearable]="true"
            [initialValue]="initialEmails"
            [addTag]="validateEmail.bind(this)"
            searchGetParam="query"
            [addTagText]="'add' | translate"
            [notFoundText]="'Projects.notFoundText' | translate"
            [placeholder]="'ProjectsDashboard.stageTasks.messageTaskSidenav.recipientPlaceholder' | translate"
          />
        </div>

        @if (showBccField()) {
          <div class="mb-3">
            <div class="new-select-label">
              {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.bcc' | translate }}
            </div>
            <ng-select
              ngSelectExtension
              class="new-select w-100"
              [url]="contactsUrl"
              [responseTransform]="successOnLoadContacts.bind(this)"
              formControlName="bcc"
              [ignoreLocalSearch]="true"
              [multiple]="true"
              bindValue="email"
              bindLabel="fullName"
              [addTag]="validateEmail.bind(this)"
              [clearable]="true"
              [searchable]="true"
              [closeOnSelect]="false"
              searchGetParam="query"
              [addTagText]="'add' | translate"
              [notFoundText]="'Projects.notFoundText' | translate"
              [placeholder]="'ProjectsDashboard.stageTasks.messageTaskSidenav.bccPlaceholder' | translate"
            />
          </div>
        }

        @if (showCcField()) {
          <div class="mb-3">
            <div class="new-select-label">
              {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.cc' | translate }}
            </div>
            <ng-select
              ngSelectExtension
              class="new-select w-100"
              [url]="contactsUrl"
              [responseTransform]="successOnLoadContacts.bind(this)"
              formControlName="cc"
              [ignoreLocalSearch]="true"
              [multiple]="true"
              bindValue="email"
              bindLabel="fullName"
              [addTag]="validateEmail.bind(this)"
              [clearable]="true"
              [searchable]="true"
              [closeOnSelect]="false"
              searchGetParam="query"
              [addTagText]="'add' | translate"
              [notFoundText]="'Projects.notFoundText' | translate"
              [placeholder]="'ProjectsDashboard.stageTasks.messageTaskSidenav.ccPlaceholder' | translate"
            />
          </div>
        }
      }

      <div class="mb-3">
        <div class="new-select-label">
          {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.subject' | translate }}
        </div>
        <div #subjectWrapper>
          <input-v2
            formControlName="subject"
            [placeholder]="'ProjectsDashboard.stageTasks.messageTaskSidenav.subjectPlaceholder' | translate"
            (focusin)="onSubjectFocus($event)"
            (click)="onSubjectCaretChanged($event)"
            (keyup)="onSubjectCaretChanged($event)"
          />
        </div>
      </div>

      <div class="process-message-task-sidenav__date-inputs mb-3">
        <div class="control-v2">
          <input-label
            [label]="'ProjectsDashboard.stageTasks.messageTaskSidenav.sendDateLabel' | translate"
          />
          <datepicker-v2
            controlName="sendDate"
            [form]="form"
            [minDate]="today"
            [title]="'ProjectsDashboard.stageTasks.messageTaskSidenav.sendDateLabel' | translate"
            (closed)="onDatepickerClose()"
          />
        </div>

        <div class="control-v2">
          <input-label
            [label]="'ProjectsDashboard.stageTasks.messageTaskSidenav.sendTimeLabel' | translate"
          />
          <input-v2
            [ngxMatTimepicker]="picker"
            formControlName="sendTime"
            format="24"
            [placeholder]="'ProjectsDashboard.stageTasks.messageTaskSidenav.sendTimeLabel' | translate"
          />
          <ngx-mat-timepicker
            #picker
            enableKeyboardInput
            (timeSet)="onTimeSet($event)"
            [cancelBtnTmpl]="cancelButton"
            [confirmBtnTmpl]="confirmButton"
            [editableHintTmpl]="hint"
          />
          <ng-template #cancelButton>
            <app-button
              [config]="{
                type: ButtonTypes.NEW_SECONDARY_BLUE,
                text: ('cancel' | translate)
              }"
            />
          </ng-template>
          <ng-template #confirmButton>
            <app-button
              class="ml-2"
              [config]="{
                type: ButtonTypes.NEW_PRIMARY_BLUE,
                text: ('confirm' | translate)
              }"
            />
          </ng-template>
          <ng-template #hint>
            <div class="hint">
              {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.timepickerHint' | translate }}
            </div>
          </ng-template>
        </div>
      </div>

      <div class="mb-3">
        <div class="new-select-label">
          {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.message' | translate }}
        </div>
        <div class="relative process-message-task-sidenav__editor">
          <quill-editor
            #editor
            [bounds]="'.process-message-task-sidenav__editor'"
            class="quill-v2 quill-custom-img-size quill-custom-matcher"
            [modules]="modules"
            [formats]="formats"
            [placeholder]="'ProjectsDashboard.stageTasks.messageTaskSidenav.messagePlaceholder' | translate"
            formControlName="content"
            (onFocus)="onEditorFocused()"
            (onSelectionChanged)="onEditorSelectionChanged($event)"
          />
        </div>
      </div>

      @if (!isSendMode()) {
        <div class="mb-4">
          <div class="new-select-label">
            {{ 'ProjectsDashboard.stageTasks.messageTaskSidenav.variables' | translate }}
          </div>
          <div class="process-message-task-sidenav__variables">
            @for (token of variableTokens; track token.key) {
              <button
                type="button"
                class="process-message-task-sidenav__variable-chip"
                (mousedown)="preventVariableBlur($event)"
                (click)="addVariable(token)"
              >
                + {{ token.label }}
              </button>
            }
          </div>
        </div>
      }

      <attachment-manager-list-v2
        #attachmentsList
        [attachmentsConfig]="attachmentsConfig"
        [uploadConfig]="attachmentUploadConfig"
        [fileAttachments]="taskAttachments"
      />
    </form>
  </div>

  <div class="sticky-footer d-flex justify-content-between">
    <app-button
      (onClick)="close()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: ('Projects.discard' | translate)
      }"
    />

    <app-button
      [loading]="saving"
      [disabled]="saving"
      (onClick)="save()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: isSendMode()
          ? ('ProjectsDashboard.stageTasks.messageTaskSidenav.sendButton' | translate)
          : ('editSave' | translate),
        prependSrc: isSendMode() ? './assets/img/business-mail-open-line.svg' : ''
      }"
    />
  </div>
</div>
